export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 90,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_projectName') || '项目名称',
    field: 'prjTitle',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'title',
  },
  {
    title: that.$l('table_label_document_type') || '文档类型',
    field: 'prjFileTypeName',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_lable_file_name') || '文件名',
    field: 'fileName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_doc_remark') || '文档说明',
    field: 'prjFileDesc',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: that.$l('table_title_uploadByName') || '上传人姓名',
    field: 'uploadName',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_upload_time') || '上传时间',
    field: 'uploadTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
